import { computed } from 'vue';
import UiIcon from '~/components/ui/UiIcon.vue';


export default {
  __name: 'UiEnergyLabelLink',
  props: {
  energyEfficiencyClass: {
    type: String,
    required: true,
  },
  linkHtml: {
    type: String,
    required: true,
  },
  height: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const iconName = computed(
  () => `${props.energyEfficiencyClass?.toLowerCase()}Class`,
);

// Extract URL from provided HTML string (expects an <a href="..."> inside)
const linkUrl = computed(() => {
  if (!props.linkHtml) return '';
  const match = props.linkHtml.match(/href=["']([^"']+)["']/i);
  return match ? match[1] : '';
});

const handleClick = (event) => {
  if (linkUrl.value) {
    window.open(linkUrl.value, '_blank');
    event.preventDefault();
  }
};

return { __sfc: true,props, iconName, linkUrl, handleClick, UiIcon }
}

}